export default {
  ADD_SIGNALS: 'config/ADD_SIGNALS',
  UPDATE_SIGNAL: 'config/UPDATE_SIGNAL',
  UPDATE_CART_MODE: 'config/UPDATE_CART_MODE',
  UPDATE_CART_COOKIE: 'config/UPDATE_CART_COOKIE',
  UPDATE_LAB_EXIT_WARNING_ELIGIBILITY:
    'config/UPDATE_LAB_EXIT_WARNING_ELIGIBILITY',
  UPDATE_LAST_SAVED: 'config/UPDATE_LAST_SAVED',
  UPDATE_STREAMLINED_MOBILE_MODE: 'config/UPDATE_STREAMLINED_MOBILE_MODE',
  UPDATE_STREAMLINED_MOBILE_INTENT: 'config/UPDATE_STREAMLINED_MOBILE_INTENT',
  SET_CLIPART_RECOLORING: 'config/SET_CLIPART_RECOLORING',
  SET_SLEEVE_PRINT_OVERRIDE: 'config/SET_SLEEVE_PRINT_OVERRIDE'
};
